import React from 'react';
import './App.css';
import './style/custom.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import BlockRoutes from './UTILS/lib/PrivateRoutes/BlockRoutes';
import LoginRoutes from './UTILS/lib/PrivateRoutes/LoginRoutes';
import DojangSelectRoutes from './UTILS/lib/PrivateRoutes/DojangSelectRoutes';
import ContainerOnlyTopbar from './UI/LAYOUT/CONTAINER/ContainerOnlyTopbar';
import ContainerWithoutSidebar from './UI/LAYOUT/CONTAINER/ContainerWithoutSidebar';
import ContainerOnlyTopbarWithLogout from './UI/LAYOUT/CONTAINER/ContainerOnlyTopbarWithLogout';
import LayoutDojang from './UI/LAYOUT/LAYOUT_ROUTES/LayoutDojang';
import LayoutAssociation from './UI/LAYOUT/LAYOUT_ROUTES/LayoutAssociation';
import LayoutDojangManagement from './UI/LAYOUT/LAYOUT_ROUTES/LayoutDojangManagement';
import CheckJoinedPG from './UTILS/lib/PrivateRoutes/CheckJoinedPG';
import CheckJoinedHealthcare from './UTILS/lib/PrivateRoutes/CheckJoinedHealthcare';
import CheckIsLogin from './UTILS/lib/PrivateRoutes/CheckIsLogin';
import commonRoutes from './routes/common';
import dojangRoutes from './routes/dojang';
import associationRoutes from './routes/association';

const Router = () => {
  return (
    <Routes>
      {/* CommonRoutes */}
      <Route element={<ContainerWithoutSidebar />}>
        {/* no layout */}
        {commonRoutes.noLayout.map((props) => (
          <Route
            key={props.path}
            {...props}
          />
        ))}
        {/* only topbar */}
        <Route element={<ContainerOnlyTopbar />}>
          {commonRoutes.onlyTopbar.map((props) => (
            <Route
              key={props.path}
              {...props}
            />
          ))}
        </Route>
        {/* only topbar with logout button */}
        <Route element={<ContainerOnlyTopbarWithLogout />}>
          {commonRoutes.onlyTopbarWithLogout.map((props) => (
            <Route
              key={props.path}
              {...props}
            />
          ))}
        </Route>
        {/* check login */}
        <Route element={<CheckIsLogin />}>
          {commonRoutes.noLayoutLogin.map((props) => (
            <Route
              key={props.path}
              {...props}
            />
          ))}
        </Route>
      </Route>

      <Route element={<BlockRoutes />}>
        {/* MasterTeacherRoutes */}
        <Route element={<LoginRoutes userRole='KWANJANG-SABUM' />}>
          <Route element={<DojangSelectRoutes />}>
            <Route element={<LayoutDojangManagement />}>
              {/* manage dojang */}
              {dojangRoutes.common.map((props) => (
                <Route
                  key={props.path}
                  {...props}
                />
              ))}
              {/* check joined hc */}
              <Route element={<CheckJoinedHealthcare />}>
                {dojangRoutes.joinedHC.map((props) => (
                  <Route
                    key={props.path}
                    {...props}
                  />
                ))}
              </Route>
            </Route>
          </Route>
          {/* unselected dojang */}
          {dojangRoutes.unselectedDojang.map((props) => (
            <Route
              key={props.path}
              {...props}
            />
          ))}
        </Route>

        {/* MasterRoutes */}
        <Route element={<LoginRoutes userRole='KWANJANG' />}>
          <Route element={<DojangSelectRoutes />}>
            <Route element={<LayoutDojangManagement />}>
              {/* manage dojang only KW */}
              {dojangRoutes.onlyKW.map((props) => (
                <Route
                  key={props.path}
                  {...props}
                />
              ))}
              {/* check joined pg */}
              <Route element={<CheckJoinedPG />}>
                {dojangRoutes.joinedPG.map((props) => (
                  <Route
                    key={props.path}
                    {...props}
                  />
                ))}
              </Route>
            </Route>

            <Route element={<LayoutDojang />}></Route>
          </Route>
          <Route element={<ContainerWithoutSidebar />}>
            {dojangRoutes.unselectedDojangOnlyKW.map((props) => (
              <Route
                key={props.path}
                {...props}
              />
            ))}
          </Route>
        </Route>

        {/* TeacherRoutes */}
        <Route element={<LoginRoutes userRole='SABUM' />}>
          <Route element={<DojangSelectRoutes />}>
            <Route element={<LayoutDojangManagement />}></Route>
          </Route>
        </Route>

        {/* AssociationRoutes */}
        <Route element={<LoginRoutes userRole='ASSOCIATION' />}>
          <Route element={<LayoutAssociation />}>
            {associationRoutes.dashboard.map((props) => (
              <Route
                key={props.path}
                {...props}
              />
            ))}
          </Route>
        </Route>
      </Route>
      {/* Exception */}
      <Route
        path='*'
        element={<Navigate to='/' />}
      />
    </Routes>
  );
};

export default Router;
